import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import styled from 'styled-components';
import {BaseComponent} from "../../../../components/BaseComponent";
import {Button} from "../../../../components/Buttons";
import {getOutgoingRestBpmCalculation} from "../../actions";
import {Modal, ModalControls} from "../../../../components/Modal";
import {Loader} from "../../../../components/Loader";
import {VBox} from "../../../../components/Box";
import {FormField} from "../../../../components/FormFields";
import {Input} from "../../../../components/Form";
import {selectOutgoingBpmCalculation} from "../../selectors";
import {selectWork} from "../../../Api/selectors";
import {PRICE_TYPES, REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION} from "../../constants";
import {BuyerCompanyField} from "./BuyerCompanyField";
import {Dropdown} from "../../../../components/Dropdown";

const Container = styled.div``;

const STATE = {
  outgoingRestBpm: null,
  outgoingCompanyId: null,
  priceType: null,
  priceAmount: null,
}

function HBOx(props) {
  return null;
}

HBOx.propTypes = {children: PropTypes.node};

/* eslint-disable react/prefer-stateless-function */
class OutgoingInvoiceInputModalComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    // this.props.getOutgoingRestBpmCalculation();
  }

  get outgoingRestBpm() {
    if (this.state.outgoingRestBpm !== null) {
      return this.state.outgoingRestBpm;
    }

    return this.props?.outgoingBpmCalculation?.currentRestBpm ?? null;
  }

  onConfirm() {
    const input = {
      outgoingRestBpm: this.outgoingRestBpm,
      outgoingCompanyId: this.state.outgoingCompanyId,
      salesAmounts: {},
    }

    if (this.state.priceType === PRICE_TYPES.EXCL_VAT_BPM) {
      input.salesAmounts.financial_price_excl_vat_excl_bpm = this.state.priceAmount;
      input.salesAmounts.financial_price_marge_excl_bpm = this.state.priceAmount;
      input.salesAmounts.outgoing_rest_bpm = this.outgoingRestBpm;
    }

    if (this.state.priceType === PRICE_TYPES.INCL_VAT_BPM) {
      input.salesAmounts.financial_price_incl_vat_bpm = this.state.priceAmount;
      input.salesAmounts.financial_price_marge_incl_bpm = this.state.priceAmount;
      input.salesAmounts.outgoing_rest_bpm = this.outgoingRestBpm;
    }

    this.props.onConfirm(input);
  }

  onClose() {
    this.props.onClose();
  }

  onChangeOutgoingCompanyId(companyId) {
    this.updateState('outgoingCompanyId', companyId);
  }

  get canApply() {
    if (!this.outgoingRestBpm && this.outgoingRestBpm !== 0) return false;
    if (!this.state.priceType || !this.state.priceAmount) return false;
    if (!this.state.outgoingCompanyId) return false;

    return true;
  }

  get priceTypeOptions() {
    return [
      {
        label: PRICE_TYPES.EXCL_VAT_BPM,
        value: PRICE_TYPES.EXCL_VAT_BPM,
      },
      {
        label: PRICE_TYPES.INCL_VAT_BPM,
        value: PRICE_TYPES.INCL_VAT_BPM,
      },
    ];
  }

  renderPriceType() {
    return (
      <VBox>
        <p>{this.lbl('invoice.generating.priceType')}</p>
        <FormField>
          <Dropdown options={this.priceTypeOptions} onChange={o => this.setState({ priceType: o.value })} value={this.state.priceType} />
        </FormField>
      </VBox>
    )
  }

  get priceAmount() {
    return this.state.priceAmount ?? '';
  }

  renderPriceAmount() {
    if (!this.state.priceType) return '';
    return (
      <VBox>
        <p>{this.lbl('invoice.generating.priceAmount')}</p>
        <FormField>
          <Input
            name="priceAmount"
            value={this.priceAmount ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    )
  }

  renderModalContent() {
    if (this.props.work || !this.props.outgoingBpmCalculation) return <Loader small/>;
    return (
      <Container>
        {this.renderRestBPMSection()}
        <VBox>
          <p>{this.lbl('invoice.generating.buyer')}</p>
          <BuyerCompanyField
            value={this.state.outgoingCompanyId}
            onChange={this.onChangeOutgoingCompanyId.bind(this)}
          />
        </VBox>
        {this.renderPriceType()}
        {this.renderPriceAmount()}
      </Container>)
  }

  renderRestBPMSection() {
    if (this.props.vehicle_purpose === 'commercial') return '';

    return (
      <React.Fragment>
        <VBox>
          <p>{this.lbl('invoice.generating.grossBpm')}</p>
          <FormField>
            <Input
              disabled={true}
              name="grossBpm"
              value={this.props.outgoingBpmCalculation.grossBpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
        <VBox>
          <p>{this.lbl('invoice.generating.purchaseRestBpm')}</p>
          <FormField>
            <Input
              disabled={true}
              name="restBpm"
              value={this.props.outgoingBpmCalculation.purchaseRestBpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
        <VBox>
          <p>{this.lbl('invoice.generating.autotelexPurchaseRestBpm')}</p>
          <FormField>
            <Input
              disabled={true}
              name="autotelexRestBpm"
              value={this.props.outgoingBpmCalculation.autotelexRestBpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
        <VBox>
          <p>{this.lbl('invoice.generating.currentRestBpm')}</p>
          <FormField>
            <Input
              name="outgoingRestBpm"
              value={this.outgoingRestBpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      </React.Fragment>
    );
  }


  render() {
    return (
      <Modal onClose={this.onClose.bind(this)} title={this.lbl(`invoice.generating.title`)}>
        {this.renderModalContent()}
        <ModalControls>
          <Button onClick={this.onConfirm.bind(this)} primary disabled={!this.canApply}>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.onClose.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

OutgoingInvoiceInputModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    outgoingBpmCalculation: selectOutgoingBpmCalculation(),
    work: selectWork(REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getOutgoingRestBpmCalculation() {
      dispatch(getOutgoingRestBpmCalculation(ownProps.vehicleId));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const OutgoingInvoiceInputModal = compose(
  withConnect,
  withRouter,
)(OutgoingInvoiceInputModalComp);
